import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import * as DashboardActions from '../../actions/dashboard_actions';
import * as serviceCallConfig from '../../config/api_urls';
import Notifications from './notifications';
import _ from 'lodash';
import Header from '../../components/header';
let screenIdentifier = 'dashboard';
/*date picker*/
import DayPicker from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';

let Dashboard = React.createClass({
    getInitialState() {
        return {
            dasboardData: null,
            isDeleting: false, selectedFromDay: null,
            selectedToDay: null, ActiveFaciltyCalled: false, ActiveFaciltyData: null, errorCsv: false, selectedFromDayDisplay: null, selectedToDayDisplay: null

        }
    },
    componentWillMount() {
        this.props.Dispatch(DashboardActions.dashboardCounts());
        this.props.Dispatch(DashboardActions.notifications());
    },
    componentWillReceiveProps(nextProps) {

        this.setState({ dasboardData: nextProps.DashboardAData.DashboardData });

        if (this.state.ActiveFaciltyCalled) {

            let A_F = nextProps.DashboardAData;
            A_F.ActiveFacilty && A_F.ActiveFacilty.status === 200 && this.setState({ ActiveFaciltyCalled: false, ActiveFaciltyData: A_F.ActiveFacilty.data })
            //this.setState({ActiveFaciltyCalled:false})
        }

    },
    componentDidMount() {
        //alert('called');
        this.props.Dispatch(DashboardActions.get_active_facilty_data());
        this.setState({ ActiveFaciltyCalled: true })

    },


    navigationHandler() {
    },
    genrateAdmiCsvReport() {

        let d = new Date();
        let data = "",
            facilityId = this.refs.clinicId.value,
            reportType = this.refs.reportType.value, //1 or 2 1=staff 2= patient
            reportName = reportType == 1 ? "clinic-report-" : "survey-report-",
            fromDate = this.state.selectedFromDay, //y-m-d
            toDate = this.state.selectedToDay, //y-m-d,
            name = reportName + fromDate + " to " + toDate; //m-d-y
        data = facilityId + "/" + reportType + "/" + fromDate + "/" + toDate;

        if (facilityId != 0 && reportType.length && fromDate && toDate) {
            window.open(serviceCallConfig.BASE_URL + serviceCallConfig.CSV_REPORT_SUPER_ADMIN + data);// this.refs.clinicId.value='';
            this.refs.clinicId.value = '';
            this.refs.reportType.value = '';
            this.setState({ selectedFromDay: '' });
            this.setState({ selectedToDay: '' });

        } else {
            this.setState({ errorCsv: true });
        }

    },
    handleFromDateChange(selectedDay, modifiers) {
        let date = this.refs["from-date"].input.value.replace(/[^\w\s]/gi, '-');

        let ds = date.split('-');
        this.setState({ selectedFromDay: ds[2] + "-" + ds[0] + "-" + ds[1] }); //yy-mm-dd
        // this.setState({ selectedFromDayDisplay: ds[0] + "-" + ds[1] + "-" + ds[2] }); //yy-mm-dd
        // this.setState({ selectedFromDayDisplay: ds[2] + "-" + ds[1] + "-" + ds[0] }); //YYYY-MM-DD
        let dateType = selectedDay._d
        console.log(date, dateType, selectedDay._d, 'date');

        this.setState({
            selectedFromDayDisplay: (((dateType.getMonth() > 8) ? (dateType.getMonth() + 1) : 
            ('0' + (dateType.getMonth() + 1))) + '/' + ((dateType.getDate() > 9) ?
            dateType.getDate() : ('0' + dateType.getDate())) + '/' + dateType.getFullYear())
        });


    },
    handleToDateChange(selectedDay, modifiers) {
        let date = this.refs["to-date"].input.value.replace(/[^\w\s]/gi, '-');
        let ds = date.split('-');
        this.setState({ selectedToDay: ds[2] + "-" + ds[0] + "-" + ds[1] });
        // this.setState({ selectedToDayDisplay: ds[0] + "-" + ds[1] + "-" + ds[2] });
        // this.setState({ selectedToDayDisplay: ds[2] + "-" + ds[1] + "-" + ds[0] }); //YYYY-MM-DD
        let dateType = selectedDay._d
        console.log(date, dateType, selectedDay._d, 'date');

        this.setState({
            selectedFromDayDisplay: (((dateType.getMonth() > 8) ? (dateType.getMonth() + 1) : 
            ('0' + (dateType.getMonth() + 1))) + '/' + ((dateType.getDate() > 9) ?
            dateType.getDate() : ('0' + dateType.getDate())) + '/' + dateType.getFullYear())
        });
    },
    genderateActiviFaciltyList() {
        //  debugger;
        //let facility_data = this.state.ActiveFaciltyData;
        let facility_data = this.props.DashboardAData && this.props.DashboardAData.ActiveFacilty && this.props.DashboardAData.ActiveFacilty.data;
        let ActivefacilitiesList = facility_data && typeof (facility_data) != "string" && facility_data.length ? facility_data.map(function (list, key) {
            return (<option key={key} value={list.id}>{list.name}</option>);
        }, this) : (<option value="NA" selected>No Clinics found</option>);
        return ActivefacilitiesList;
    },
    removeError() {
        this.setState({ errorCsv: false });
    },
    render() {
        let formDate = this.state.selectedFromDay ? this.state.selectedFromDayDisplay : "";
        let toDate = this.state.selectedToDay ? this.state.selectedToDayDisplay : "";

        let ActivefacilitiesList = this.genderateActiviFaciltyList();
        const startDayPickerProps = {
            disabledDays: {
                after: new Date(),
            }
        };
        const endDayPickerProps = {
            disabledDays: {
                before: new Date(this.state.selectedFromDay),
                after: new Date(),
            }
        };
        return (
            <div>
                <header>
                    <Header screenIdentifier={screenIdentifier} />
                </header>
                <div className="dashboard-inner-content">
                    <div className="row">
                        <div className="col-xs-6 padding-left-none">
                            <div className="white-box summary">
                                <h3>Summary</h3>
                                <div className="row">
                                    <div className="col-xs-6 padding-left-none">
                                        <h4>Total Clinics</h4>
                                        <div className="dashboard-number">
                                            <p className="big-font orange">{this.state.dasboardData ? this.state.dasboardData.totalFacility : 0}</p>
                                        </div>
                                        <h4>Total staff</h4>
                                        <div className="dashboard-number">
                                            <p className="big-font blue">{this.state.dasboardData ? this.state.dasboardData.totalStaff : 0}</p>
                                        </div>
                                    </div>
                                    <div className="col-xs-6 padding-right-none">
                                        <h4>Total Mobi admins</h4>
                                        <div className="dashboard-number">
                                            <p className="big-font purple">{this.state.dasboardData ? this.state.dasboardData.totalAdmins : 0}</p>
                                        </div>
                                        <h4>Total patients</h4>
                                        <div className="dashboard-number">
                                            <p className="big-font green">{this.state.dasboardData ? this.state.dasboardData.totalPatient : 0}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-xs-6 padding-left-5 padding-right-none">
                            <div className="white-box generate">
                                <h3>SELECT REPORT</h3>
                                <form className="Generate-form">
                                    <div className="row">

                                        <div className="col-xs-6 padding-left-none padding-right-none">
                                            <div className="aj-dropdown">
                                                <div className="source">
                                                    <div className="question-selection">
                                                        <select required="" ref="clinicId" onFocus={this.removeError}>
                                                            <option value="" default>Select Clinic</option>
                                                            {ActivefacilitiesList}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 padding-left-5 padding-right-none">
                                            <div className="aj-dropdown">
                                                <div className="source">
                                                    <div className="question-selection">
                                                        <select required="" ref="reportType" onFocus={this.removeError}>
                                                            <option value="" default="">Report Type</option>
                                                            <option value="2">Survey Report</option>
                                                            <option value="1">Clinic Report</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                                <div className="generate-date">
                                    <div className="col-xs-6 padding-left-5 padding-right-none from-date" onFocus={this.removeError}>
                                        <span className="">Start date : </span>
                                        <DayPickerInput format="M/D/YYYY" readOnly ref="from-date" onDayChange={this.handleFromDateChange} value={formDate}
                                         dayPickerProps={startDayPickerProps} placeholder="MM/DD/YYYY" />
                                    </div>

                                    <div className="col-xs-6 padding-left-5 padding-right-none to-date" onFocus={this.removeError}>
                                        <span className="from ">End date :  </span>
                                        <DayPickerInput format="M/D/YYYY" readOnly ref="to-date" onDayChange={this.handleToDateChange} value={toDate} dayPickerProps={endDayPickerProps} placeholder="MM/DD/YYYY" />
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                            <div className="buttonSubmit">
                                <button className={this.refs.clinicId && (this.refs.clinicId.value != 'NA' || this.refs.clinicId.value == '0') ? "generateCsv" : "generateCsv disabled"} onClick={this.genrateAdmiCsvReport} type="submit">Generate Csv </button>
                            </div>
                            {this.state.errorCsv && <p className="error">Please enter necessary fields to proceed.</p>}
                        </div>
                    </div>
                    <Notifications />

                </div>
            </div>
        );
    }
});

let mapStateToProps = (state) => {

    return {

        DashboardAData: state.Dashboard

    };
};

let mapDispatchToProps = (dispatch) => ({
    DashboardActions: bindActionCreators(DashboardActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Dashboard));



/** WEBPACK FOOTER **
 ** ./src/components/dashboardScreen/dashboard.js
 **/